"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var rxjs_1 = require("rxjs");
var operators_1 = require("rxjs/operators");
var inversify_1 = require("inversify");
var metadataKeys_1 = require("./metadataKeys");
var utils_1 = require("./utils");
var tokens = __importStar(require("./tokens"));
var operators_2 = require("./operators");
var RxStore = /** @class */ (function () {
    function RxStore() {
        var _this = this;
        this.dispatch = function (action) {
            _this.action$.next(action);
        };
        this.destroy = function () {
            if (_this.unsubscriber) {
                _this.unsubscriber.unsubscribe();
            }
        };
        this.serviceNeedLinkConfigs = [];
        this.setTypesValue();
        this.setAsyncTypesValue();
    }
    Object.defineProperty(RxStore.prototype, "storeConfig", {
        get: function () {
            var configLinkService = this._storeConfig ? this._storeConfig.linkService : {};
            return {
                linkService: __assign({ dataSelector: function (payload) { return payload; }, errorSelector: function (payload) { return payload; } }, configLinkService),
            };
        },
        enumerable: true,
        configurable: true
    });
    RxStore.prototype.linkService = function (linkServiceConfig) {
        this.serviceNeedLinkConfigs.push(linkServiceConfig);
    };
    RxStore.prototype.init = function (options) {
        var _this = this;
        this.options = options;
        var configLinkService = this.storeConfig.linkService;
        var reducer = function (state, action) {
            var _a;
            for (var _i = 0, _b = _this.serviceNeedLinkConfigs; _i < _b.length; _i++) {
                var config = _b[_i];
                var stateKey = config.state, asyncType = config.type, dataSelector = config.dataSelector, errorSelector = config.errorSelector;
                var finalDataSelector = dataSelector || configLinkService.dataSelector;
                var finalErrorSelector = errorSelector || configLinkService.errorSelector;
                var type = action.type, payload = action.payload;
                switch (type) {
                    case asyncType.START:
                    case asyncType.END:
                    case asyncType.ERR: {
                        var asyncState = __assign({}, state[stateKey]);
                        switch (type) {
                            case asyncType.START: {
                                asyncState.loading = true;
                                asyncState.err = null;
                                break;
                            }
                            case asyncType.END: {
                                asyncState.loading = false;
                                asyncState.data = finalDataSelector(payload);
                                break;
                            }
                            case asyncType.ERR: {
                                asyncState.loading = false;
                                asyncState.err = finalErrorSelector(payload);
                                break;
                            }
                        }
                        state = __assign({}, state, (_a = {}, _a[stateKey] = asyncState, _a));
                    }
                }
            }
            return _this.options.reducer(state, action);
        };
        this.state$ = this.action$.pipe(operators_1.scan(reducer, this.options.initialState), operators_1.distinctUntilChanged(), operators_1.shareReplay(1));
        var effectNames = Reflect.getMetadata(metadataKeys_1.effectNamesKey, this);
        var effectMethodNames = effectNames ? effectNames.split('|') : [];
        var effects = [];
        for (var _i = 0, effectMethodNames_1 = effectMethodNames; _i < effectMethodNames_1.length; _i++) {
            var name_1 = effectMethodNames_1[_i];
            effects.push(this[name_1]());
        }
        var _loop_1 = function (config) {
            if (utils_1.isLinkServiceConfig(config)) {
                var type_1 = config.type;
                effects.push(this_1.action$.pipe(operators_2.ofType(type_1.START), operators_1.switchMap(function (_a) {
                    var payload = _a.payload;
                    return config.service(payload).pipe(operators_1.map(function (res) { return ({ type: type_1.END, payload: res }); }), operators_1.catchError(function (err) { return rxjs_1.of({ type: type_1.ERR, payload: err }); }));
                })));
            }
            else {
                console.error('invalid service link config:', config);
            }
        };
        var this_1 = this;
        for (var _a = 0, _b = this.serviceNeedLinkConfigs; _a < _b.length; _a++) {
            var config = _b[_a];
            _loop_1(config);
        }
        var actionWithEffects$ = rxjs_1.merge.apply(void 0, effects).pipe(operators_1.tap(function (action) {
            if (utils_1.isAction(action)) {
                _this.dispatch(action);
            }
        }));
        var withEffect$ = rxjs_1.merge(this.state$, actionWithEffects$);
        this.unsubscriber = withEffect$.subscribe();
        this.dispatch({ type: Symbol('@@INIT') });
    };
    RxStore.prototype.setTypesValue = function () {
        var typeNamesStr = Reflect.getMetadata(metadataKeys_1.typeDefNamesKey, this) || '';
        var typeNames = typeNamesStr.split('|');
        for (var _i = 0, typeNames_1 = typeNames; _i < typeNames_1.length; _i++) {
            var name_2 = typeNames_1[_i];
            this[name_2] = Symbol(name_2);
        }
    };
    RxStore.prototype.setAsyncTypesValue = function () {
        var asyncTypeNamesStr = Reflect.getMetadata(metadataKeys_1.asyncTypeDefNamesKey, this) || '';
        var asyncTypeNames = asyncTypeNamesStr.split('|');
        for (var _i = 0, asyncTypeNames_1 = asyncTypeNames; _i < asyncTypeNames_1.length; _i++) {
            var name_3 = asyncTypeNames_1[_i];
            this[name_3] = {
                START: Symbol(name_3 + "/START"),
                END: Symbol(name_3 + "/END"),
                ERR: Symbol(name_3 + "/ERR"),
            };
        }
    };
    __decorate([
        inversify_1.inject(tokens.ActionStream),
        __metadata("design:type", rxjs_1.Subject)
    ], RxStore.prototype, "action$", void 0);
    __decorate([
        inversify_1.inject(tokens.RxStoreConfig),
        inversify_1.optional(),
        __metadata("design:type", Object)
    ], RxStore.prototype, "_storeConfig", void 0);
    RxStore = __decorate([
        inversify_1.injectable(),
        __metadata("design:paramtypes", [])
    ], RxStore);
    return RxStore;
}());
exports.RxStore = RxStore;
//# sourceMappingURL=RxStore.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@awaw00/rxstore/lib/RxStore.js
// module id = 156
// module chunks = 0